export const SOCIAL_MEDIA = [
  {

  }
]

export const UNSPLASH_URL = 'https://unsplash.com/@andikanu'
export const LOLANANO_URL = 'https://lolanano.com'